import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';
export const createBuilderTextMetadata = key => _ref => {
  let {
    t
  } = _ref;
  return {
    type: DataType.text,
    defaultValue: {
      type: 'static',
      value: t(key)
    }
  };
};
export const createBuilderTextMetadataWithValue = (value, aiDescription) => () => ({
  type: DataType.text,
  defaultValue: {
    type: 'static',
    value
  },
  ai: {
    description: aiDescription
  }
});
//# sourceMappingURL=createBuilderTextMetadata.js.map